import { accountingApi } from '../config/apiClient';
import { CARD_MANAGEMENT_API } from '../config/api';

export const cardManagementService = {
  // CardType
  getCardTypes: (companyId: string) => accountingApi.get(CARD_MANAGEMENT_API.CARD_TYPES),
  createCardType: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_TYPE_CREATE, data),
  updateCardType: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_TYPE_UPDATE, data),
  deleteCardType: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_TYPE_DELETE, data),

  // Wallet
  getWallets: (companyId: string) => accountingApi.get(CARD_MANAGEMENT_API.WALLETS),
  createWallet: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.WALLET_CREATE, data),
  updateWallet: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.WALLET_UPDATE, data),
  deleteWallet: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.WALLET_DELETE, data),

  // Card
  getCards: (companyId: string, params?: { page?: number; pageSize?: number; search?: string; cardTypeId?: number; walletId?: number; accountId?: string; sessionStatus?: string }) =>
    accountingApi.get(CARD_MANAGEMENT_API.CARDS(params)),
  getCardById: (id: number, companyId: string) => accountingApi.get(CARD_MANAGEMENT_API.CARD_BY_ID(id)),
  getCardByUID: (companyId: string, cardUID: string) => accountingApi.get(CARD_MANAGEMENT_API.CARD_BY_UID(cardUID)),
  /** Bir personele bağlı kartlar (personel detayındaki Kartlar bölümü). */
  getCardsByPersonnel: (firebaseUid: string) =>
    accountingApi.get(CARD_MANAGEMENT_API.CARDS_BY_PERSONNEL(firebaseUid)),
  getCardTransactions: (id: number, companyId: string, params?: { page?: number; pageSize?: number; walletId?: number }) =>
    accountingApi.get(CARD_MANAGEMENT_API.CARD_TRANSACTIONS(id, params)),
  createCard: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_CREATE, data),
  updateCard: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_UPDATE, data),
  /** Turnike UID eşleştirme — turnstileCardUID null/boş ise eşleştirme kaldırılır (unpair). */
  pairTurnstileUid: (data: { cardId: number; turnstileCardUID: string | null; updatedBy?: string }) =>
    accountingApi.post(CARD_MANAGEMENT_API.CARD_PAIR_TURNSTILE_UID, data),
  deleteCard: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_DELETE, data),
  restoreCard: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_RESTORE, data),
  hardDeleteCard: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_HARD_DELETE, data),
  checkCardExists: (companyId: string, params?: { cardNumber?: string; cardUID?: string }) =>
    accountingApi.get(CARD_MANAGEMENT_API.CARD_CHECK_EXISTS(params)),
  getDeletedCards: (companyId: string, params?: { page?: number; pageSize?: number; search?: string }) =>
    accountingApi.get(CARD_MANAGEMENT_API.CARDS_DELETED(params)),
  getMasterCards: () => accountingApi.get(CARD_MANAGEMENT_API.MASTER_CARDS),

  // Session
  openSession: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.SESSION_OPEN, data),
  closeSession: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.SESSION_CLOSE, data),
  getActiveSession: (companyId: string, cardId: number) => accountingApi.get(CARD_MANAGEMENT_API.SESSION_ACTIVE(cardId)),
  getSessionHistory: (companyId: string, cardId: number, page?: number, pageSize?: number) =>
    accountingApi.get(CARD_MANAGEMENT_API.SESSION_HISTORY(cardId, page, pageSize)),
  getSessionTransactions: (sessionId: number, companyId: string, page?: number, pageSize?: number) =>
    accountingApi.get(CARD_MANAGEMENT_API.SESSION_TRANSACTIONS(sessionId, page, pageSize)),
  getAllSessions: (companyId: string, params?: { page?: number; pageSize?: number; cardId?: number; status?: string; search?: string }) =>
    accountingApi.get(CARD_MANAGEMENT_API.SESSIONS_ALL(params)),

  // Balance
  loadBalance: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.LOAD_BALANCE, data),
  withdrawBalance: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.WITHDRAW_BALANCE, data),
  purchaseFromCard: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.CARD_PURCHASE, data),
  refundPurchaseItem: (data: any) => accountingApi.post(CARD_MANAGEMENT_API.REFUND_PURCHASE_ITEM, data),

  // Purchase items
  getSessionPurchaseItems: (sessionId: number, companyId: string, onlyUnreceipted?: boolean) =>
    accountingApi.get(CARD_MANAGEMENT_API.SESSION_PURCHASE_ITEMS(sessionId, onlyUnreceipted)),
  getStockMovementsByReference: (referenceId: string, companyId: string) =>
    accountingApi.get(CARD_MANAGEMENT_API.STOCK_MOVEMENTS_BY_REFERENCE(referenceId)),
  markSessionReceipted: (sessionId: number, data: { FiscalSaleNumber?: string; FiscalInvoiceNo?: string; FiscalTransactionData?: string }) =>
    accountingApi.post(CARD_MANAGEMENT_API.MARK_SESSION_RECEIPTED(sessionId), data),

  // Summary
  getSummary: (companyId: string) => accountingApi.get(CARD_MANAGEMENT_API.SUMMARY),
};
